// extracted by mini-css-extract-plugin
export default {"backdrop":"ErrorDialog_backdrop__NAP2m","errorContainer":"ErrorDialog_errorContainer__I9xTT","cross":"ErrorDialog_cross__P6A6u","close":"ErrorDialog_close__dXO41"};